$(function () {
    $(document).on("click", ".tabs__item-link", function () {
        const class_content = $(this).parents('.tabs').attr('data-class-content');
        let currentTabItem = $(this).parents('.tabs').find('.tabs__item--active');

        currentTabItem.removeClass('tabs__item--active');
        $(this).parent().addClass('tabs__item--active');

        $('.' + class_content).addClass(class_content + '--hidden');
        console.log(currentTabItem.attr('data-id'));
        console.log(class_content);

        $('.' + $(this).parent().attr('data-id')).removeClass(class_content + '--hidden');
        $('#' + $(this).parent().attr('data-id')).removeClass(class_content + '--hidden');
    });
});